export const LayoutType = {
    list: "list",
    grid: "grid"
}

export const RootElementId = "tvg-root";